export enum AppNodes {
    Section = 'section', 
    Row     = 'row',
    Seat    = 'seat',
    Ga      = 'general_admission',
}